import {
    ADMIN_HANDLE_BUILDING,
    ADMIN_SET_BUILDINGS,
    ADMIN_SET_BUILDING_ENTRY,
    ADMIN_SET_CLIENTS,
    ADMIN_SET_CLIENT_ENTRY,
    ADMIN_SET_TENANTS,
    ADMIN_SET_TENANT_ENTRY,
    ADMIN_SET_USERS,
    ADMIN_SET_PROPERTIES,
    ADMIN_SET_PROPERTY_ENTRY,
    ADMIN_SET_REGIONS,
    ADMIN_SET_REQUESTS,
    ADMIN_SET_REQUEST_ENTRY,
    ADMIN_REMOVE_REQUEST_ENTRY,
    ADMIN_SET_TENANTS_ADD,
    ADMIN_UPDATE_TENANT,
    ADMIN_UPDATE_BUILDING,
    ADMIN_SET_GROUPS,
    ADMIN_UPDATE_GROUP,
    ADMIN_SET_GROUP_ENTRY,
    ADMIN_REMOVE_TENANT,
} from '../actionTypes'

const defaultState = {
    isLoading: false,
    buildings: [],
    clients: [],
    properties: [],
    regions: [],
    tenants: [],
    users: [],
    requests: [],
    notificationTemplates: [],
    groups: [],
}

const adminReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ADMIN_HANDLE_BUILDING:
            return {
                ...state,
                handledBuilding: true,
                isLoading: false,
            }
        case ADMIN_SET_BUILDINGS:
            return {
                ...state,
                buildings: action.buildings ? action.buildings : [],
            }

        case ADMIN_SET_BUILDING_ENTRY:
            return {
                ...state,
                buildings: [...state.buildings, action.entry],
            }

        case ADMIN_UPDATE_BUILDING:
            return {
                ...state,
                buildings: state.buildings.map((building) =>
                    building.pk === action.building.pk ? action.building : building
                ),
            }

        case ADMIN_SET_CLIENTS:
            return {
                ...state,
                clients: action.clients,
            }

        case ADMIN_SET_CLIENT_ENTRY:
            return {
                ...state,
                clients: [...state.clients, action.client],
            }

        case ADMIN_SET_TENANTS:
            return {
                ...state,
                tenants: action.tenants ? [...action.tenants] : [],
            }

        case ADMIN_SET_TENANT_ENTRY:
            return {
                ...state,
                tenants: [...state.tenants, action.tenant],
            }

        case ADMIN_SET_TENANTS_ADD:
            const uniqueObjects = action.tenants.filter(
                newObj =>
                    !state.tenants.some(
                        existingObj => existingObj.pk === newObj.pk // Replace 'id' with your unique property name
                    )
            );
            return {
                ...state,
                tenants: [...state.tenants, ...uniqueObjects],
            }

        case ADMIN_UPDATE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map((tenant) =>
                    tenant.id === action.tenant.id ? action.tenant : tenant
                ),
            }

        case ADMIN_REMOVE_TENANT:
            return {
                ...state,
                tenants: state.tenants.filter((t) => t.pk !== action.tenant.pk),
            }

        case ADMIN_SET_PROPERTIES:
            return {
                ...state,
                properties: action.properties,
            }

        case ADMIN_SET_PROPERTY_ENTRY:
            return {
                ...state,
                properties: [...state.properties, action.entry],
            }

        case ADMIN_SET_REGIONS:
            return {
                ...state,
                regions: action.regions,
            }

        case ADMIN_SET_REQUESTS:
            return {
                ...state,
                requests: action.requests ? action.requests : [],
            }

        case ADMIN_SET_REQUEST_ENTRY:
            return {
                ...state,
                requests: [...state.requests, action.request],
            }
        case ADMIN_REMOVE_REQUEST_ENTRY:
            return {
                ...state,
                requests: state.requests.filter((r) => r.pk !== action.request.pk),
            }
       
        default:
            return state
    }
}

export default adminReducer
